// extracted by mini-css-extract-plugin
export default {"wrapper":"Index_wrapper__hfNcG","layout":"Index_layout__idGvc","content":"Index_content__Y9m-L","hasMenuId":"Index_hasMenuId__NtfWM"};